import { render, staticRenderFns } from "./grBtnLite.vue?vue&type=template&id=355d4644&scoped=true&"
import script from "./grBtnLite.vue?vue&type=script&lang=js&"
export * from "./grBtnLite.vue?vue&type=script&lang=js&"
import style0 from "./grBtnLite.vue?vue&type=style&index=0&id=355d4644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355d4644",
  null
  
)

export default component.exports